import { useEffect, useState } from 'react';

const wrapLongWord = (
  word: string,
  context: CanvasRenderingContext2D,
  containerWidth: number,
): { lines: string[]; remainder: string } => {
  const lines: string[] = [];
  let charLine = '';
  for (const char of word) {
    const testCharLine = charLine + char;
    if (context.measureText(testCharLine).width > containerWidth) {
      if (charLine) lines.push(charLine);
      charLine = char;
    } else {
      charLine = testCharLine;
    }
  }
  return { lines, remainder: charLine + ' ' };
};

const wrapParagraph = (
  para: string,
  context: CanvasRenderingContext2D,
  containerWidth: number,
): string[] => {
  const lines: string[] = [];
  let line = '';

  for (const word of para.split(' ')) {
    const testLine = line + word + ' ';

    if (context.measureText(testLine).width <= containerWidth) {
      line = testLine;
      continue;
    }

    if (line.trim()) {
      lines.push(line.trim());
    }

    if (context.measureText(word).width > containerWidth) {
      const wrapped = wrapLongWord(word, context, containerWidth);
      lines.push(...wrapped.lines);
      line = wrapped.remainder;
    } else {
      line = word + ' ';
    }
  }

  if (line.trim()) {
    lines.push(line.trim());
  }
  return lines;
};

const countVisualLines = (
  text: string,
  context: CanvasRenderingContext2D,
  containerWidth: number,
): number => {
  const lines: string[] = [];
  for (const para of text.split('\n')) {
    if (para.trim() === '') {
      lines.push('');
    } else {
      lines.push(...wrapParagraph(para, context, containerWidth));
    }
  }
  return lines.length;
};

export const useTextLineCount = (
  ref: React.RefObject<HTMLTextAreaElement>,
  text: string,
): number => {
  const [lineCount, setLineCount] = useState(0);

  useEffect(() => {
    if (!ref.current) return;

    const textarea = ref.current;
    const style = getComputedStyle(textarea);

    const font = `${style.fontSize} ${style.fontFamily}`;
    const paddingLeft = Number.parseFloat(style.paddingLeft);
    const paddingRight = Number.parseFloat(style.paddingRight);
    const containerWidth = textarea.clientWidth - paddingLeft - paddingRight;

    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    if (!context) return;

    context.font = font;
    setLineCount(countVisualLines(text, context, containerWidth));
  }, [ref, text]);

  return lineCount;
};
